import React from "react";
import SlideShow from "Components/Header/SlideShow";
import HeaderNav from "Components/HeaderNav";
import Menu from "Components/Header/Menu";

export default () => (
  <header>
    <HeaderNav />
    <SlideShow />
    <Menu />
  </header>
);
